import { render, staticRenderFns } from "./InvestmentsUpdateBox.vue?vue&type=template&id=6cc58f7a&scoped=true"
import script from "./InvestmentsUpdateBox.vue?vue&type=script&lang=js"
export * from "./InvestmentsUpdateBox.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsUpdateBox.vue?vue&type=style&index=0&id=6cc58f7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc58f7a",
  null
  
)

export default component.exports